// Module
var code = "<div data-bind=\"geWindow: $data, header: 'Carrier Tractors', modalSize: 'lg', align: true\" style=\"background-color:rgba(0,0,0,.5)\"> <div class=\"panel-body\" id=\"divCarrierTractorsPanel\"> <div id=\"carrierTractorsGrid\"></div> </div> </div> ";
// Exports
export default code;